/**
 * Payment Slice
 * Flutter source: lib/presentation/utils/payment_utils.dart:6-9
 *
 * App-level Redux state for payment-related globals (the Revolut exchange
 * rate from USD to the wallet's local currency, and the active Revolut
 * environment). Flutter stores both as static singletons on PaymentUtils;
 * on web we hold them here so any feature can read them synchronously.
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { RevolutEnvironment } from '@/domain/enums/payment/revolutEnvironment';
import type { RootState } from '@/presentation/store';

interface PaymentState {
  exchangeRate: number | null;
  revolutEnvironment: RevolutEnvironment;
}

const initialState: PaymentState = {
  exchangeRate: null,
  revolutEnvironment: RevolutEnvironment.sandbox,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    setExchangeRate: (state, action: PayloadAction<number | null>) => {
      state.exchangeRate = action.payload;
    },
    clearExchangeRate: (state) => {
      state.exchangeRate = null;
    },
    setRevolutEnvironment: (state, action: PayloadAction<RevolutEnvironment>) => {
      state.revolutEnvironment = action.payload;
    },
  },
});

export const { setExchangeRate, clearExchangeRate, setRevolutEnvironment } = paymentSlice.actions;
export default paymentSlice.reducer;

// --- Selectors ---

export const selectExchangeRate = (state: RootState): number | null =>
  state.payment.exchangeRate;

export const selectRevolutEnvironment = (state: RootState): RevolutEnvironment =>
  state.payment.revolutEnvironment;
